import { type InferGetServerSidePropsType } from 'next';

import { AdminRoute } from '@admin/routing/AdminRoute';
import { getNextAdminServerSidePropsWrapper } from '@admin/routing/serverSideProps';
import { IndexPage, type State } from '@admin/templates';
import { getNewsCategories } from '@admin/templates/news-category/helpers';
import { type NewsCategory } from '@common/clients/api';
import { type PrepareProps } from '@common/types/DefaultProps';

type PageProps = { state: State; categories: NewsCategory[] };

const prepareProps: PrepareProps<PageProps> = async (contextData, userContext) => {
    const categories = await getNewsCategories({ contextData, userContext });
    const state = {
        dataIsOutdated: false,
    } satisfies State;

    return {
        props: {
            state,
            categories,
        },
    };
};

export const getServerSideProps = getNextAdminServerSidePropsWrapper<PageProps>(
    AdminRoute.Index,
    prepareProps,
);

export type IndexPageProps = InferGetServerSidePropsType<typeof getServerSideProps>;

export default IndexPage;
